import React from "react";
import { Link, useNavigate } from "react-router-dom";
import SeeMore from "assets/images/svg/see_more.svg";
import { RelatedApp } from "pages/details/app-detail.service";
import { json } from "helpers/data";
import StarIcon from "assets/images/svg/rate_s.svg";
import { ColoredLabel } from "components/classes";
import { FavIcon } from "components/favIcon";
import {useTranslation} from "react-i18next";
import ServerImage from "components/server-image/server-image";

interface Props {
  apps: RelatedApp[];
}

function RelatedApps({ apps }: Props) {
    const {t} = useTranslation('details')
    const navigate = useNavigate()
  if (apps.length <= 0) return null;
  return (
    <div className="relatedApp row">
      <h1 className="title">{t('appDetails.relatedApps')}</h1>
      {apps.map((app) => (
        <div className="col-4" key={app.id}>
          <div  className="app" >
            <div className="d-flex justify-content-between">
              <ServerImage
                className="logo"
                src={app.logo.fullPath}
                alt={json(app.title)}
              />
              <FavIcon />
            </div>
         <div onClick={()=>navigate(`/app/${app.id}`)} className="cursor-pointer">
         <h2>{json(app.title)}</h2>
            {app.label && (
              <ColoredLabel color={app.label.color}>
                {json(app.label?.name ?? "")}
              </ColoredLabel>
            )}
            <span>{app.rate}</span>
            <span>
              <img src={StarIcon} alt="star" />
            </span>
            <span className="reviewers-count">({app.reviewersCount})</span>

            {app.price && (
              <p className="price">
                <span className="from">from </span>
                <span>{app.price?.netPrice} </span>
                <span className="currency">
                  {json(app.price?.currencySymbol) ?? "SAR"}
                </span>
              </p>
            )}
         </div>
          </div>
        </div>
      ))}
      <Link to="/browse-apps" className="col-4 viewAll">
        <img src={SeeMore} alt="see-more" />
        <p>{t('appDetails.viewAllProducts')}</p>
      </Link>
    </div>
  );
}

export default RelatedApps;
